import { render, staticRenderFns } from "./GenericVideo.vue?vue&type=template&id=24a0d343&"
import script from "./GenericVideo.vue?vue&type=script&lang=js&"
export * from "./GenericVideo.vue?vue&type=script&lang=js&"
import style0 from "./GenericVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports